/** @jsx jsx */
import { ErrorBoundary as ErrorBoundaryBase } from '@datacamp/waffles/error-boundary';
import { Link } from '@datacamp/waffles/link';
import { Paragraph } from '@datacamp/waffles/paragraph';
import { jsx } from '@emotion/react';
import raven from 'raven-js';
import React from 'react';

const CustomFallback: React.FC = () => {
  return (
    <div
      css={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
      }}
    >
      <Paragraph css={{ maxWidth: 500, textAlign: 'center' }}>
        Something went wrong, please reload the page or visit our{' '}
        <Link href="https://support.datacamp.com/" rel="noopener noreferrer">
          Support page
        </Link>{' '}
        if the problem persists.
      </Paragraph>
    </div>
  );
};

type Props = {
  children: React.ReactNode;
};

const ErrorBoundary: React.FC<Props> = ({ children }) => {
  return (
    <ErrorBoundaryBase
      fallback={<CustomFallback />}
      onError={(error) => {
        raven.captureException(error);
      }}
    >
      {children}
    </ErrorBoundaryBase>
  );
};

export default ErrorBoundary;
